import { useState, useEffect, useMemo } from 'react';
import { useAlert } from '../contexts/AlertContext';
import { feedbackApi } from '../services/api';
import { getAssignmentStatus } from '../constants/assignmentStatuses';
import { REVIEW_TYPES } from '../constants/reviewTypes';
import { getNumericLevel } from '../constants/skillLevels';

export const useFeedbackReport = (assignmentId, onDataLoaded) => {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(true);
  const [reportData, setReportData] = useState(null);
  const [error, setError] = useState(null);
  const [sortedReviewers, setSortedReviewers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await feedbackApi.getAssignmentReport(assignmentId);
        setReportData(data);
        
        if (onDataLoaded) {
          onDataLoaded({
            hasFeedbackOnDemand: !!data?.feedbackOnDemand?.completedAt,
            reportEmployeeId: data?.employeeId,
            assignmentStatus: getAssignmentStatus(data),
            // ADR-014 §7b: parent session closed (snapshot close) => read-only
            isLocked: !!(data?.isLocked || data?.feedbackSession?.completedAt),
            fullReportData: data
          });
        }
        
        if (data && data.reviewers) {
          const sorted = [...data.reviewers].sort((a, b) => {
            if (a.order !== undefined && b.order !== undefined) {
              return a.order - b.order;
            }
            if (a.reviewerType && b.reviewerType) {
              if (a.reviewerType === 'self' && b.reviewerType !== 'self') return -1;
              if (a.reviewerType !== 'self' && b.reviewerType === 'self') return 1;
            }
            return 0;
          });
          setSortedReviewers(sorted);
        }
      } catch (error) {
        console.error('Error fetching feedback report:', error);
        setError(error.message || 'Failed to fetch feedback report');
        showAlert(error.message || 'Failed to fetch feedback report', 'error', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [assignmentId, onDataLoaded]);

  return {
    loading,
    reportData,
    error,
    sortedReviewers
  };
}; 